export default __webpack_public_path__ + "road-map-500-a3a5936946841276b190ec89f4c219ea.webp";